module.exports = __webpack_public_path__ + "media/images/features/support/heading-type-mail-2ea848d29abea24e368f8748a4f5fbe1.svg";